import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BASE_URL } from '../constants'
import { IToken, IUser } from '../model/interfaces'
import { RootState, store } from '../redux/store'
import { getTokenFromLocalStorage } from '../../utils'

export const sequenceProjectApi = createApi({
  reducerPath: 'sequenceProjectApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_URL}/sequenceProject`,
    headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
  }),
  tagTypes: ['sequenceProject'],
  endpoints: (builder) => ({
    getSequenceProject: builder.query<string[], void>({
      query: () => {
        const authData: IToken = {
          ...(store.getState() as RootState).auth
        }
        return {
          method: 'GET',
          url: ``,
          headers: { Authorization: `Bearer ${authData.token}` }
        }
      },
      providesTags: ['sequenceProject']
    }),
    createSequenceProject: builder.mutation<void, string[]>({
      query: (sequenceProject: string[]) => {
        const user: IUser = {
          ...(store.getState() as RootState).user.user
        }
        return {
          method: 'POST',
          url: '',
          body: { user, sequence: sequenceProject },
          headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
        }
      },
      invalidatesTags: ['sequenceProject']
    }),
    updateSequenceProject: builder.mutation<void, string[]>({
      query: (sequenceProject: string[]) => {
        const user: IUser = {
          ...(store.getState() as RootState).user.user
        }
        return {
          method: 'PUT',
          url: `/${user._id}`,
          body: { sequence: sequenceProject },
          headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
        }
      },
      invalidatesTags: ['sequenceProject']
    }),
    deleteSequenceProject: builder.mutation<void, string>({
      query: (id: string) => ({
        method: 'DELETE',
        url: `/${id}`,
        headers: { Authorization: `Bearer ${getTokenFromLocalStorage()}` }
      }),
      invalidatesTags: ['sequenceProject']
    })
  })
})

export const {
  useGetSequenceProjectQuery,
  useLazyGetSequenceProjectQuery,
  useCreateSequenceProjectMutation,
  useUpdateSequenceProjectMutation,
  useDeleteSequenceProjectMutation
} = sequenceProjectApi
